import SecondaryNav from 'Benchmarks/SecondaryNav';
import React, { useState } from 'react';
import ProcurementMetricsNumerical from './ProcurementMetricsContainer/ProcurementMetricsNumerical';
import ProcurementMetricsCategorical from './ProcurementMetricsContainer/ProcurementMetricsCategorical';
import { ContentDiv, FlexWrapper, NavDiv } from './ProcurementMetrics.styles';
import { ApButtonTab } from '@alixpartners/ui-components';
import ProcurementMetricsContextProvider from './Context/ProcurementMetricsContextProvider';

const ProcurementMetrics = () => {
	const INITIAL_SUBNAV_CONFIG = [
		{
			id: 0,
			name: 'tab1',
			label: 'Procurement Metrics (Numerical) ',
			isActive: true,
			component: ProcurementMetricsNumerical,
		},
		{
			id: 1,
			name: 'tab2',
			label: 'Procurement Metrics (Categorical)',
			isActive: false,
			component: ProcurementMetricsCategorical,
		},
		// {
		// 	id: 2,
		// 	name: 'tab3',
		// 	label: 'tab3',
		// 	isActive: false,
		// 	component: ProcurementMetricsContainer2,
		// },
	];
	const [subNav, setSubNav] = useState(INITIAL_SUBNAV_CONFIG);
	const [activeTabId, setActiveTabId] = useState(0);

	const subNavHandler = value => {
		setActiveTabId(value);
		setSubNav(prevState =>
			prevState.map(el => {
				if (el.id === value) {
					return { ...el, isActive: true };
				} else {
					return { ...el, isActive: false };
				}
			})
		);
	};

	return (
		<ProcurementMetricsContextProvider activeTabId={activeTabId}>
			<SecondaryNav />
			<FlexWrapper>
				<NavDiv>
					{subNav.map(({ id, name, label, isActive }) => (
						<ApButtonTab
							key={id}
							name={name}
							isSelected={isActive}
							onClick={() => {
								subNavHandler(id);
							}}
							small
						>
							{label}
						</ApButtonTab>
					))}
				</NavDiv>
			</FlexWrapper>
			<ContentDiv>
				{subNav.map(({ id, isActive, component: Component }) => {
					return isActive && <Component key={id} />;
				})}
			</ContentDiv>
		</ProcurementMetricsContextProvider>
	);
};

export default ProcurementMetrics;
